<template>
    <img v-if="imageUrl" :src="imageUrl" alt="ga"
         style="width: 0;height: 0;opacity: 0;">
</template>

<script>
import query from "query-string";

export default {
    name: "GtagImage",

    data() {
        return {
            imageUrl: null,
        }
    },

    watch: {
        "$route.path": {
            immediate: true,
            handler: function (path) {
                if (localStorage.getItem('__ua_cid') === null) {
                    localStorage.setItem('__ua_cid', this.generateUuid());
                }
                this.imageUrl = query.stringifyUrl({
                    url: 'https://www.google-analytics.com/collect',
                    query: {
                        v: 1,
                        tid: this.$analyticsId,
                        cid: localStorage.getItem('__ua_cid'),
                        t: 'pageview',
                        dh: 'cocolink.jp',
                        dp: path,
                        dt: document.title,
                    }
                });
            }
        }
    },

    methods: {
        generateUuid() {
            let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
            for (let i = 0, len = chars.length; i < len; i++) {
                switch (chars[i]) {
                    case "x":
                        chars[i] = Math.floor(Math.random() * 16).toString(16);
                        break;
                    case "y":
                        chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
                        break;
                }
            }
            return chars.join("");
        }
    }
}
</script>

<style scoped>

</style>
